import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import Parse from 'parse'
import {
  Route
} from 'react-router-dom'

export default class CoachFeedbackListComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      feedbacks: null,
      loadError: null
    }
    this.loadContent()
  }

  loadContent = async () => {
    console.log('Loading coach feedback...')
    try {
      const query = new Parse.Query('WorkoutCoachFeedback')
      query.descending('createdAt')
      query.limit(100)
      const results = await query.find()
      console.log('Coach feedback loaded:', results.length)
      this.setState({
        feedbacks: results,
        loadError: null
      })
    } catch (error) {
      console.error('Error getting coach feedback:', error)
      this.setState({
        loadError: error.message
      })
    }
  }

  numberOfResultsText = () => {
    if (this.state.loadError) return null
    if (!this.state.feedbacks) return (<i>Loading...</i>)
    if (this.state.feedbacks.length === 100) return (<i>100+ results</i>)
    return (<i>{this.state.feedbacks.length} results</i>)
  }

  renderErrorBanner = () => {
    if (!this.state.loadError) return null
    return (
      <div className="alert alert-danger" role="alert">
        <b>Error loading coach feedback:</b> {this.state.loadError}
      </div>
    )
  }

  renderTableHeader = () => {
    return (
      <tr key={'0-header'} className="data">
        <th className="bg-primary" key={'0h'}>Date Created ▾</th>
        <th className="bg-primary" key={'1h'}>Feedback Text</th>
        <th className="bg-primary" key={'2h'}>Completed Workout</th>
      </tr>
    )
  }

  renderTable = () => {
    if (!this.state.feedbacks) return ''
    if (!this.state.feedbacks.length) {
      return (
        <tr className="data">
          <td colSpan="3">
            <span className="text-muted">No coach feedback found</span>
          </td>
        </tr>
      )
    }
    return this.state.feedbacks.map((feedback, index) => {
      const completedWorkoutId = feedback.get('completedWorkoutId')
      return (
        <tr key={index} className="data">
          <td>
            {feedback.get('createdAt').toLocaleString()}
          </td>
          <td>
            {feedback.get('text')}
          </td>
          <td>
            {completedWorkoutId
              ? (
                <a href={'/#/completedWorkouts/' + completedWorkoutId}>
                  {completedWorkoutId}
                </a>
                )
              : (
                <span className="text-muted">N/A</span>
                )}
          </td>
        </tr>
      )
    })
  }

  render = () => {
    return (
      <div>
        <Route path="/coachFeedback">
          <div className="container">
            <br/>
            <div>
              <h1 id="title">Coach Feedback</h1>
            </div>
            <br/>
            {this.renderErrorBanner()}
            <table id="coachfeedback" className="data">
              <tbody>
                {this.renderTableHeader()}
                {this.renderTable()}
              </tbody>
            </table>
            <br/>
            {this.numberOfResultsText()}
            <br/>
          </div>
        </Route>
      </div>
    )
  }
}
